// extracted by mini-css-extract-plugin
module.exports = {"modal":"DeleteBoardModal_modal__3ksXw","modal_background":"DeleteBoardModal_modal_background__2Qk2S","modal-content":"DeleteBoardModal_modal-content__maT3D"};